module.exports = __webpack_public_path__ + "static/media/inktoberCampfire.cea5cb4d.gif";